<form [formGroup]="reminderForm" (ngSubmit)="onSubmit()">
    <div mat-dialog-title>
        {{(isModifying && isEditMode) ? 'Edit' : (isModifying ? '' : 'Add New')}}  Reminder
    </div>
    <mat-dialog-content class="pt-3">
        <mat-form-field>
            <mat-label>Reminder Title</mat-label>
            <input matInput formControlName="reminderTitle" [readonly]="!isEditMode" [minlength]="minReminderTitleLength"  [maxlength]="maxReminderTitleLength">
            <mat-hint align="end">{{ reminderTitle?.value?.length || 0 }} / {{ maxReminderTitleLength  }}</mat-hint>
            <mat-error *ngIf="reminderTitle?.errors?.required && reminderTitle?.touched">
                Reminder title is required.
            </mat-error>
            <mat-error *ngIf="reminderTitle?.errors?.minlength && reminderTitle?.touched">
                Reminder title must be at least {{ reminderTitle?.errors?.minlength.requiredLength }} characters long.
            </mat-error>
            <mat-error *ngIf="reminderTitle?.errors?.maxlength && reminderTitle?.touched">
                Reminder title cannot be more than {{ reminderTitle?.errors?.maxlength.requiredLength }} characters long.
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" [readonly]="!isEditMode"  [minlength]="minDescriptionLength" [maxlength]="maxDescriptionLength"></textarea>
            <mat-hint align="end">{{ description?.value?.length || 0 }} / {{ maxDescriptionLength }}</mat-hint>
            <mat-error *ngIf="description?.errors?.minlength && description?.touched">
                Description must be at least {{ description?.errors?.minlength.requiredLength }} characters long.
            </mat-error>
            <mat-error *ngIf="description?.errors?.maxlength && description?.touched">
                Description cannot be more than {{ description?.errors?.maxlength.requiredLength }} characters long.
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Reminder Date</mat-label>
            <input matInput [matDatepicker]="picker1" [readonly]="true" formControlName="reminderDate" [disabled]="!isEditMode"  [min]="minDate" (click)="isEditMode && picker1.open()">
            <mat-datepicker-toggle matSuffix [for]="picker1" [disabled]="!isEditMode"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error *ngIf="reminderDate?.invalid && reminderDate?.touched">
                Reminder date is required.
            </mat-error>
            <mat-hint>
                <strong>Format:</strong> DD MMM YYYY
            </mat-hint>
        </mat-form-field>

        <mat-form-field class="mt-3">
                <mat-label>Reminder Time</mat-label>
                <input matInput [ngxTimepicker]="timePicker" [readonly]="true"
                       formControlName="reminderTime" [format]="12"
                       required>
                <ngx-material-timepicker #timePicker ></ngx-material-timepicker>
                <mat-error *ngIf="reminderTime?.invalid && reminderTime?.touched">
                    Reminder time is required.
                </mat-error>
                <mat-hint>
                    <strong>Format:</strong> HH:MM AM/PM
                </mat-hint>
            </mat-form-field>

        <mat-form-field class="mt-3">
            <mat-label>Notify</mat-label>
            <mat-select formControlName="earlyReminderTime" [disabled]="!isEditMode">
                <mat-option *ngFor="let option of reminderList" [value]="option.value" >{{ option.label }}</mat-option>
            </mat-select>
        </mat-form-field>

    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="d-flex flex-fill gap-3 align-items-center justify-content-between">
            <div>
                <button type="button" *ngIf="isModifying && reminderStatus != ReminderStatus.COMPLETED" mat-stroked-button color="accent" (click)="markAsComplete()">Mark As Done</button>
            </div>
            <div>
                <button mat-stroked-button mat-dialog-close color="warn">Close</button>
                <button *ngIf="isModifying && !isEditMode && reminderStatus != ReminderStatus.COMPLETED" mat-raised-button color="primary" (click)="toggleEditMode()">Edit</button>
                <button *ngIf="isEditMode" mat-raised-button color="primary" type="submit" [disabled]="!reminderForm.valid">{{isModifying ? 'Update' : 'Create'}}</button>
            </div>
        </div>
    </mat-dialog-actions>
</form>